import { use, useEffect, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
// import { _delete_customer_api, _list_customer_api } from "../../DAL/User/User";
import { useSnackbar } from "notistack";
import { makeStyles } from "@mui/styles";
import moment from "moment";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import CustomConfirmation from "../../components/customComponents/confirmation/CustomConfirmation";
import CustomMUITable from "../../components/customComponents/table/CustomMuiTable";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import {
  change_attorney_percentage_api,
  delete_attorney_Api,
  get_pool_attorney_list,
} from "../../DAL/adminAuth/auth";
import { formatExpertise, show_proper_words } from "../../utils/constant";
import { percent } from "framer-motion";
import ChangePercentageDialog from "../../components/customComponents/ChangePercentageDialog";

const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
}));

const AttorneyPoolList = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmmitting, setIsSubmmitting] = useState(false);
  const [openReasonDialog, setOpenReasonDialog] = useState(false);
  const { pool_id } = useParams();
  const [advisorId, setAdvisorId] = useState("");
  const [fetchDta, setFetchData] = useState();
  const [headerName, setHeaderName] = useState("");

  const location = useLocation();
  const data = location?.state?.attorney_data;

  const EMPTY_FILTER = {
    percentage: "",
  };

  const [filterData, setFilterData] = useState(EMPTY_FILTER);

  const [userList, setUserList] = useState([]);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [totalCount, setTotalCount] = useState(0);
  const [pageCount, setPageCount] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalCaseCaseCapacity, setTotalCaseCapacity] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [states, setStates] = useState([]); // multiple states array
  const [caseType, setCaseType] = useState(null);

  const get_user_list = async (case_type, stateSend) => {
    setIsLoading(true);

    const result = await get_pool_attorney_list(
      pool_id,
      searchText,
      page,
      rowsPerPage
    );
    if (result.code === 200) {
      let data = result.advisor.map((item, index) => {
        let created_At = "N/A";
        let expertise = "N/A";
        let state = "N/A";
        let advisor = "N/A";
        let caseCapacity = "N/A";
        let caseDetails = "N/A";
        let case_type = "N/A";
        let caseCount = 0;
        let email = "N/A";
        let status = "N/A";
        let assigned_cases_count = 0;
        let pending_case_count = 0;
        let closed_cases_count = 0;
        let failed_cases_count = 0;
        let success_rate_completed = 0 + "%";
        let success_rate = 0 + "%";
        if (item?.failed_cases_count) {
          failed_cases_count = item.failed_cases_count;
        }
        if (item?.closed_cases_count) {
          closed_cases_count = item.closed_cases_count;
        }
        if (item?.pending_case_count) {
          pending_case_count = item.pending_case_count;
        }
        if (item?.assigned_cases_count) {
          assigned_cases_count = item.assigned_cases_count;
        }
        if (item?.percentage_allocation) {
          success_rate_completed = item.percentage_allocation + "%";
        }
        if (item?.success_rate_completed) {
          success_rate = item.success_rate_completed + "%";
        }

        if (item?.caseCount) {
          caseCount = item.caseCount;
        }

        if (item.createdAt) {
          created_At = moment(item.createdAt).format("DD-MM-YYYY");
        }
        if (item.name) {
          advisor = item.name;
        }
        if (item.caseCapacity) {
          caseCapacity = item.caseCapacity + "%";
        }

        if (item.status) {
          status = item?.status;
        }

        if (item.email) {
          email = item?.email;
        }
        if (item.state && item.state.length > 0) {
          state = item?.state;
        }
        if (item.expertise && item.expertise.length > 0) {
          expertise = item.expertise;
        }

        return {
          ...item,
          created_At,
          case_type,
          email,
          status,
          state,
          caseDetails,
          advisor,
          caseCapacity,
          expertise,
          caseCount,
          success_rate_completed,
          assigned_cases_count,
          closed_cases_count,
          failed_cases_count,
          success_rate,
          pending_case_count,
        };
      });
      setUserList(data);
      setTotalCount(result.total_count);
      setTotalPages(result.total_pages);
      // Ensure total case capacity never exceeds 100%
      const totalCapacity = Math.min(result.total_case_capacity || 0, 100);
      setTotalCaseCapacity(totalCapacity);
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  };
  const handleReasonDialogOpen = (row) => {
    setAdvisorId(row?._id);
    setHeaderName(row?.name);
    setFilterData((prev) => ({
      ...prev,
      percentage: row?.percentage_allocation,
    }));
    setOpenReasonDialog(true);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    if (newPage <= 0) {
      setPageCount(1);
    } else {
      setPageCount(newPage + 1);
    }
  };
  const handleExportCsv = async () => {
    try {
      if (!userList || userList.length === 0) {
        enqueueSnackbar("No data found to export", { variant: "info" });
        return;
      }

      const csvHeaders = [
        { label: "Name", key: "name" },
        { label: "Email", key: "email" },
        { label: "State", key: "state" },
        { label: "Success Rate", key: "success_rate" },
        { label: "Case Capacity", key: "percentage_allocation" },
        { label: "Case Type", key: "expertise" },
        { label: "Total Assigned Cases", key: "assigned_cases_count" },
        { label: "Total Pending Cases", key: "pending_case_count" },
        { label: "Total Recovered Cases", key: "closed_cases_count" },
        { label: "Total Failed Cases", key: "failed_cases_count" },
        { label: "Status", key: "status" },
      ];

      // Prepare data for CSV
      const csvData = userList?.map((item) => ({
        name: item.name || "N/A",
        email: item.email || "N/A",
        state: Array.isArray(item.state)
          ? item.state.join(", ")
          : item.state || "N/A",
        success_rate: item.success_rate || "0%",
        percentage_allocation: item.percentage_allocation
          ? `${item.percentage_allocation}%`
          : "N/A",
        expertise: formatExpertise(item.expertise) || "N/A",
        assigned_cases_count: item.assigned_cases_count || 0,
        pending_case_count: item.pending_case_count || 0,
        closed_cases_count: item.closed_cases_count || 0,
        failed_cases_count: item.failed_cases_count || 0,
        status: item.status === true ? "Active" : "Inactive",
      }));

      const headerRow = csvHeaders.map((h) => h.label).join(",");
      const rows = csvData.map((row) =>
        csvHeaders
          .map((h) => `"${(row[h.key] ?? "").toString().replace(/"/g, '""')}"`)
          .join(",")
      );
      const csvContent = [headerRow, ...rows].join("\n");

      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `attorney_pools_export_${moment().format("YYYY-MM-DD_HH-mm")}.csv`
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      enqueueSnackbar("Something went wrong while exporting", {
        variant: "error",
      });
      console.error(error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilterData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangePages = (event, newPage) => {
    if (newPage <= 0) {
      setPage(0);
      setPageCount(1);
    } else {
      setPage(newPage - 1);
      setPageCount(newPage);
    }
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const searchFunction = (e) => {
    e.preventDefault();
    setPage(0);
    setPageCount(1);
    get_user_list();
  };

  const MENU_OPTIONS = [
    {
      label: "Change Percentage",
      icon: "ic:round-change-circle",
      handleClick: handleReasonDialogOpen,
    },
  ];

  const handleChangePercentage = async () => {
    console.log("called.....");
    if (filterData.percentage === "") {
      enqueueSnackbar("Percentage is required", { variant: "error" });
      return;
    }

    // Calculate remaining percentage
    const currentPercentage = parseInt(filterData.percentage) || 0;

    // Only validate if totalCaseCapacity is >= 100%

    setIsSubmmitting(true);
    let data = {
      advisor_id: advisorId,
      pool_id: pool_id,
      allocation_percentage: filterData.percentage,
    };
    const response = await change_attorney_percentage_api(data);
    if (response.code === 200) {
      enqueueSnackbar(response?.message, { variant: "success" });
      setIsSubmmitting(false);
      handleReasonDialogClose();
      get_user_list();
    } else {
      enqueueSnackbar(response?.message, { variant: "error" });
      setIsSubmmitting(false);
    }
  };

  const TABLE_HEAD = [
    {
      id: "action",
      label: "Action",
      type: "action",
      MENU_OPTIONS: "MENU_OPTIONS",
    },
    { id: "number", label: "#", type: "number" },
    { id: "name", label: "Name" },
    { id: "email", label: "Email" },
    { id: "success_rate", label: "Success Rate" },

    {
      id: "state",
      label: "State",
      renderData: (row) => {
        const states = Array.isArray(row?.state) ? row.state : [];
        const formattedStates = [];
        for (let i = 0; i < states.length; i += 2) {
          formattedStates.push(states.slice(i, i + 2).join(", "));
        }
        return (
          <span>
            {formattedStates.map((line, index) => (
              <span key={index}>
                {line}
                {index !== formattedStates.length - 1 && <br />}
              </span>
            ))}
          </span>
        );
      },
    },
    {
      id: "percentage_allocation",
      label: "Case Capacity",
      renderData: (row) => {
        return (
          <span className="d-flex justify-content-center">
            {row?.percentage_allocation + "%"}
          </span>
        );
      },
    },
    // { id: "caseCount", label: "Case Count" },
    {
      id: "expertise",
      label: "Case Type",
      renderData: (row) => {
        return <span>{formatExpertise(row?.expertise)}</span>;
      },
    },
    { id: "assigned_cases_count", label: "Total Assigned Cases" },
    { id: "pending_case_count", label: "Total Pending Cases" },
    { id: "closed_cases_count", label: "Total Recovered Cases" },
    { id: "failed_cases_count", label: "Total Failed Cases" },
    { id: "status", label: "Status", type: "row_status" },
  ];
  const handleReasonDialogClose = () => {
    setOpenReasonDialog(false);
    setFilterData((old) => ({
      ...old,
      percentage: "",
    }));
  };
  useEffect(() => {
    get_user_list();
  }, [page, rowsPerPage]);
  let oldPercentage = 0;
  if (openReasonDialog && headerName && userList.length > 0) {
    const found = userList.find((u) => u.name === headerName);
    if (found && found.percentage_allocation) {
      oldPercentage = parseInt(found.percentage_allocation) || 0;
    }
  }
  const currentValue = parseInt(filterData.percentage) || 0;
  const newTotal = totalCaseCaseCapacity - oldPercentage + currentValue;
  const isOverAllocation = newTotal > 100;

  if (isLoading === true) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }

  return (
    <>
      <div className="mt-1">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center">
            <IconButton
              className="back-screen-button "
              onClick={() => navigate(-1)}
            >
              <ArrowBackIcon />
            </IconButton>
            <div className="page-title-box">
              <h4>
                Attorneys
                <br /> <span style={{ fontSize: "16px" }}>
                  ({data?.title})
                </span>{" "}
              </h4>
            </div>
          </div>
          <div className="text-end">
            <Button
              variant="contained"
              startIcon={<DownloadIcon />}
              onClick={handleExportCsv}
            >
              Export CSV
            </Button>
          </div>
        </div>
      </div>
      <div className="mt-4">
        <CustomMUITable
          data={userList}
          TABLE_HEAD={TABLE_HEAD}
          MENU_OPTIONS={MENU_OPTIONS}
          pagePagination={true}
          custom_pagination={{
            total_count: totalCount,
            rows_per_page: rowsPerPage,
            page: page,
            handleChangePage: handleChangePage,
            onRowsPerPageChange: handleChangeRowsPerPage,
          }}
          custom_search={{
            searchText: searchText,
            setSearchText: setSearchText,
            handleSubmit: searchFunction,
          }}
          pageCount={pageCount}
          totalPages={totalPages}
          handleChangePages={handleChangePages}
        />
      </div>
      <ChangePercentageDialog
        open={openReasonDialog}
        onClose={handleReasonDialogClose}
        headerName={headerName}
        filterData={filterData}
        handleChange={handleChange}
        handleChangePercentage={handleChangePercentage}
        isOverAllocation={isOverAllocation}
        isSubmitting={isSubmmitting}
        userList={userList}
        totalCaseCaseCapacity={totalCaseCaseCapacity}
      />
    </>
  );
};

export default AttorneyPoolList;
